module.exports = __webpack_public_path__ + "static/media/journal.f3363eeb.png";